export default __webpack_public_path__ + "static/media/splash_antoinfo_2-1.0943704c.mp3";